import { MERCURIO_API } from "@/config/apis.js";
import axios from "axios";

const _basicHeaders = {
  "Content-Type": "application/json",
  "Access-Control-Allow-Origin": "*",
  "Access-Control-Allow-Methods": "GET, PUT, POST, DELETE, OPTIONS"
};

const getRadarsFromPoint = async point => {
  /* Get radars from closest to farest */
  const url = `${MERCURIO_API.private}/MSP/Radars/?lon=${point.lon}&lat=${
    point.lat
  }`;

  const res = await axios.get(url, {
    headers: _basicHeaders
  });
  return res.data;
};

const getProducts = async (momentId, typeId, isRawData) => {
  const url = `${
    MERCURIO_API.private
  }/MSP/ProductRecords/${momentId}/${typeId}?isRawData=${isRawData}`;
  const res = await axios.get(url, {
    headers: _basicHeaders
  });
  return res.data;
};

const getProduct = async id => {
  const url = `${MERCURIO_API.private}/MSP/Product/${id}`;
  const res = await axios.get(url, {
    headers: _basicHeaders
  });
  return res.data;
};

const getProductsInPoint = async (momentId, typeId, isRawData, point) => {
  const url = `${
    MERCURIO_API.private
  }/MSP/ProductRecords/${momentId}/${typeId}?isRawData=${isRawData}&lon=${
    point.lon
  }&lat=${point.lat}`;

  const res = await axios.get(url, {
    headers: _basicHeaders
  });
  return res.data;
};

const getVariableTypes = async params => {
  const res = await axios.get(
    `${MERCURIO_API.public}/ProductMoments/${
      params.momentId
    }/VariableTypes?isRawData=${params.isRawData}`
  );
  return res.data;
};

export {
  getRadarsFromPoint,
  getProducts,
  getProduct,
  getProductsInPoint,
  getVariableTypes
};
